<template>
  <div>
    <p style="margin: 30px 0 15px;"><strong class="avoid">Terms and conditions of agreement for {{ hotelName }} including </strong></p>
    <div v-for="(termCondition, index) of dataList" :key="`term-condition-${index}`" class="avoid">
      <p class="avoid" v-html="bindTermAndCondition(termCondition)"></p>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'

export default {
  name: 'TermAndCondition',
  props: {
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    hotelName: {
      type: String,
      default: ''
    }
  },
  methods: {
    bindTermAndCondition: function (termAndCondition) {
      const title = get(termAndCondition, 'title', '')
      const termAndConditionDetail = get(termAndCondition, 'detail', '')
      const detail = termAndConditionDetail.replace(/(?:\r\n|\r|\n)/g, '<br>')

      let termAndConditionHtml = ''

      if (title !== '') {
        termAndConditionHtml += `<strong class="avoid">${title}</strong><br>`
      }

      if (detail !== '') {
        termAndConditionHtml += `<span class="avoid">${detail}</span>`
      }

      return termAndConditionHtml
    }
  }
}
</script>
